import YesNoQuestionPage from "@components/YesNoQuestionPage"

export default function PetsExperimentingPage() {
  return <YesNoQuestionPage translationKey="petsExperimenting" />
}
